import { IContactsWithMultiplePartners } from 'onboarding/features/models/contactsWithMultiplePartners'

export const getUniquePartnerIds = (
  contacts: IContactsWithMultiplePartners[],
  email?: string
): string[] => {
  let filteredContacts = contacts

  if (email) {
    const normalizedEmail = email.toLowerCase()
    filteredContacts = contacts.filter((contact) => contact.email.toLowerCase() === normalizedEmail)
  }

  const partnerIds = filteredContacts.map((contact) => contact.partnerId)
  return Array.from(new Set(partnerIds))
}
